import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { SafeAny } from '../../types/safe-any';
import { ApiErrorType } from '../app.actions';

import { UserDetails } from './user.state.interface';

export const UserApiActions = createActionGroup({
  source: 'UserApi',
  events: {
    Login: props<{
      payload: SafeAny;
    }>(),
    'Login Success': props<{
      payload: SafeAny;
    }>(),
    'Login Error': props<{
      payload: ApiErrorType;
    }>(),

    LoadLocalStorage: emptyProps(),
    LoadLocalStorageSuccess: props<{
      payload: SafeAny;
    }>(),
    LoadLocalStorageError: props<{
      payload: ApiErrorType;
    }>(),

    Logout: emptyProps(),

    // Add Users
    'Add User': props<{
      payload: SafeAny;
    }>(),
    'Add User Success': props<{
      addedUser: UserDetails;
    }>(),
    'Add User Error': props<{
      error: ApiErrorType;
    }>(),

    // Fetch Active Users
    'Fetch Active Users': props<{
      payload: SafeAny;
    }>(),
    'Fetch Active Users Success': props<{
      users: UserDetails[];
      totalCount: number;
    }>(),
    'Fetch Active Users Error': props<{
      error: ApiErrorType;
    }>(),

    // Fetch Archived Users
    'Fetch Archived Users': props<{
      payload: SafeAny;
    }>(),
    'Fetch Archived Users Success': props<{
      users: UserDetails[];
      totalCount: number;
    }>(),
    'Fetch Archived Users Error': props<{
      error: ApiErrorType;
    }>(),

    // Archive User
    'Archive User': props<{
      userId: string;
    }>(),
    'Archive User Success': props<{
      archivedUser: UserDetails;
    }>(),
    'Archive User Error': props<{
      error: ApiErrorType;
    }>(),

    // Fetch Specific User
    'Fetch User': props<{
      userId: string;
    }>(),
    'Fetch User Success': props<{
      user: UserDetails;
    }>(),
    'Fetch User Error': props<{
      error: ApiErrorType;
    }>(),

    // Unarchive User
    'Unarchive User': props<{
      userId: string;
    }>(),
    'Unarchive User Success': props<{
      unarchivedUser: UserDetails;
    }>(),
    'Unarchive User Error': props<{
      error: ApiErrorType;
    }>(),

    Noop: emptyProps(),

    // Update User
    'Update User': props<{
      payload: SafeAny;
      userId: string;
    }>(),
    'Update User Success': props<{
      updatedUser: UserDetails;
    }>(),
    'Update User Error': props<{
      error: ApiErrorType;
    }>(),

    // Fetch User Roles
    'Fetch User Roles': props<{
      payload: SafeAny;
    }>(),
    'Fetch User Roles Success': props<{
      roles: SafeAny[];
    }>(),
    'Fetch User Roles Error': props<{
      error: ApiErrorType;
    }>(),

    // Reset Password
    'Reset Password': props<{
      userId: string;
    }>(),
    'Reset Password Success': emptyProps(),
    'Reset Password Error': props<{
      error: ApiErrorType;
    }>(),

    // Change Password
    'Change Password': props<{
      payload: SafeAny;
      userId: string;
    }>(),
    'Change Password Success': props<{
      changedPassword: SafeAny[];
    }>(),
    'Change Password Error': props<{
      error: ApiErrorType;
    }>(),
  },
});
